<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('common.labels.create_role') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.role') }} <strong>{{ role.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
            <app-role-new *ngIf="newMode()"></app-role-new>
            <app-role-basedata *ngIf="editMode()" [role]="role" (setEdit)="setEdit($event)"></app-role-basedata>
          </p-tabPanel>

          <p-tabPanel *ngIf="sysMode === 'planner'" header="{{ t('common.labels.data_scopes') }}" leftIcon="pi pi-filter" [disabled]="isDisabled('data-scopes') || role === null">
            <app-role-data-scopes *ngIf="editMode()" [role]="role" (setEdit)="setEdit($event)"></app-role-data-scopes>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
